/**
 *  v2 テンプレート専用
 *  tab-contents の切り替え (bootstrap.jsの置き換え)
 **/
$(function() {
  'use strict';

  // クッキーではなく localStorage へ保存（Cookie Header へ載らないようにする）
  var STORAGE_KEY = 'moko_tab_states_v2';
  var MAX_STATES = 30;

  var TabCookie = {
    get: function() {
      if (!window.localStorage) {
        return {};
      }

      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        var states = raw ? JSON.parse(raw) : {};
        return states && typeof states === 'object' ? states : {};
      } catch (e) {
        return {};
      }
    },
    set: function(value) {
      if (!window.localStorage) {
        return;
      }

      try {
        if (!value || typeof value !== 'object') {
          return;
        }
        var entries = Object.keys(value);
        if (entries.length > MAX_STATES) {
          entries.sort(function(a, b) {
            return (value[b].updated_at || 0) - (value[a].updated_at || 0);
          });
          var next = {};
          for (var i = 0; i < MAX_STATES; i++) {
            var key = entries[i];
            if (value[key]) {
              next[key] = value[key];
            }
          }
          value = next;
        }
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
      } catch (e) {
        // localStorage 容量制限などは無視
      }
    }
  };

  // タブ切り替え処理
  function switchTab($tab) {
    var selector = $tab.attr('href');
    var $target = $(selector);
    if (!$target.length) return;

    // コンテンツ切り替え
    var $oldPane = $target.parent().find('> .active');
    if ($oldPane.length) {
      $oldPane.removeClass('active');
    }
    $target.addClass('active');

    // タブボタン切り替え
    var $oldTab = $tab.parent().find('> .disabled');
    if ($oldTab.length) {
      $oldTab.removeClass('disabled');
    }
    $tab.addClass('disabled');

    // 状態保存（data-remember="true" の場合）
    var $container = $tab.closest('[data-remember="true"]');
    if ($container.length) {
      var groupId = $container.attr('id');
      if (groupId) {
        var states = TabCookie.get();
        var tabId = $tab.attr('aria-controls') || selector.replace('#', '');
        if (tabId) {
          states[groupId] = {
            tab: tabId,
            updated_at: Date.now()
          };
        }
        TabCookie.set(states);
      }
    }
  }

  // クリックイベント
  $(document).on('click', '[data-toggle="tab"]', function(e) {
    e.preventDefault();
    var $this = $(this);

    if ($this.hasClass('active')) return;
    if ($this.hasClass('disabled')) return;

    switchTab($this);
  });

  // ページロード時に保存された状態を復元
  $('[data-remember="true"]').each(function() {
    var $container = $(this);
    var groupId = $container.attr('id');
    if (!groupId) return;

    var states = TabCookie.get();
    var current = states[groupId] || {};
    var savedTabId = current.tab;
    if (!savedTabId) return;

    // 保存されたタブを探してアクティブにする
    var $savedTab = $container.find('[data-toggle="tab"][aria-controls="' + savedTabId + '"]');
    if (!$savedTab.length) {
      $savedTab = $container.find('[data-toggle="tab"][href="#' + savedTabId + '"]');
    }
    if ($savedTab.length && !$savedTab.hasClass('disabled')) {
      switchTab($savedTab);
    }
  });

});
